"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsUrlOrDomain = containsUrlOrDomain;
/**
 * Regex pattern that matches common URLs or domain names.
 *
 * It flags:
 *  - Links starting with http://, https://, or www.
 *  - Common domain endings such as .com, .net, .io, etc.
 *
 * Examples (invalid / matches):
 *  - http://example.com
 *  - www.mygame.io
 *  - test.io
 *
 * Examples (allowed / non-matches):
 *  - Dr. Who
 *  - Best.GameDev
 *  - Game Developer
 */
const URL_OR_DOMAIN_PATTERN = /(https?:\/\/|www\.)|\.(?:com|net|io|org|co|dev|app|gg|ai|xyz|me|tv|tk|kids)(?:\/|[^a-z0-9]|$)/i;
/**
 * Checks whether the given input string contains a URL or domain-like pattern.
 *
 * This function uses a predefined regex to detect URLs or domain names
 * (e.g., "http://example.com", "www.mysite.io", "test.gg").
 *
 * @param input - The string to test.
 * @returns True if the input contains a URL or domain-like pattern, false otherwise.
 *
 * @example
 * containsUrlOrDomains("Visit: https://example.com") -> true
 *
 * @example
 * containsUrlOrDomains("CrazyGames is great") -> false
 */
function containsUrlOrDomain(input) {
    return URL_OR_DOMAIN_PATTERN.test(input);
}
